const Menu = [
  {
    title: "Dashboard",
    group: "apps",
    icon: "home",
    name: "ProductDashboard"
  },
  {
    title: "Products",
    group: "apps",
    icon: "shopping_basket",
    items: [
      {
        name: "ProductList",
        title: "View Product",
        component: "ProductList"
      },
      {
        name: "AddProduct",
        title: "Add Product",
        component: "AddProduct"
      }
    ]
  },
  {
    title: "Orders",
    group: "apps",
    name: "Orders",
    icon: "list"
  },
  {
    title: "Shipping",
    group: "apps",
    icon: "local_shipping",
    name: "AutoDelivery"
  },
  {
    title: "Insights",
    group: "widgets",
    component: "widgets",
    icon: "insert_chart_outlined",
    name: "Insight"
  },
  {
    title: "Settings",
    group: "widgets",
    component: "widgets",
    icon: "settings_applications",
    name: "Settings"
  }
];
// reorder menu
Menu.forEach(item => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }
});

export default Menu;
